import React from "react";

import ReusableModal from "components/Modals/ReusableModal";


const DeleteAssessment = ({
    isOpen,
    onClose,
    onConfirm,
    assessmentTitle,
}) => {

    const bodyMessage = `
        Are you sure you want to delete
        <strong>${assessmentTitle || "this assessment"}</strong>?
        This action cannot be undone.
    `;


    return (

        <ReusableModal

            isOpen={isOpen}

            onClose={onClose}

            onConfirm={onConfirm}

            title="Confirm Delete"

            bodyMessage={
                <div
                    dangerouslySetInnerHTML={{
                        __html:
                            bodyMessage,
                    }}
                />
            }

            confirmLabel="Confirm"

            cancelLabel="Cancel"
        />
    );
};


export default DeleteAssessment;